// AdminShell — layout completo do painel admin (header + sidebar + main com Outlet)
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import { getAuth, clearAuth } from '../../lib/auth.js';
import LogoMais from '../../components/LogoMais.jsx';

export default function AdminShell() {
  const auth = getAuth();
  const nav  = useNavigate();
  const ehAdmin = auth?.operador?.papel === 'admin';

  if (!ehAdmin) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <div className="card error" style={{ maxWidth: 500, margin: '0 auto' }}>
          <h3>Acesso negado</h3>
          <p>Esta área é restrita a administradores. Seu papel atual é: <code>{auth?.operador?.papel || '(não logado)'}</code></p>
          <Link to="/" className="btn primary" style={{ marginTop: 12 }}>← Voltar pra operação</Link>
        </div>
      </div>
    );
  }

  function sair() {
    clearAuth();
    nav('/login');
  }

  return (
    <div className="admin-layout">
      {/* HEADER do admin */}
      <header className="admin-header">
        <div className="admin-header-left">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <LogoMais size={32} mostrarTexto={false} />
          </Link>
          <div>
            <div style={{ fontSize: 11, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Painel</div>
            <div style={{ fontSize: 16, fontWeight: 700 }}>Administração</div>
          </div>
        </div>
        <div className="admin-header-right">
          <Link to="/" className="btn small secondary">← Voltar para operação</Link>
          <span style={{ fontSize: 12, color: '#9ca3af' }}>{auth?.operador?.username}</span>
          <button className="btn small secondary" onClick={sair}>Sair</button>
        </div>
      </header>

      {/* Sidebar + main */}
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <div className="admin-sidebar-head">
            <span className="admin-badge">ADMIN</span>
          </div>
          <nav className="admin-nav">
            <NavLink to="/admin"            end className={({isActive})=>'admin-link'+(isActive?' active':'')}>📊 Visão geral</NavLink>
            <NavLink to="/admin/usuarios"        className={({isActive})=>'admin-link'+(isActive?' active':'')}>👥 Usuários</NavLink>
            <NavLink to="/admin/frota"           className={({isActive})=>'admin-link'+(isActive?' active':'')}>🚙 Frota</NavLink>
            <NavLink to="/admin/kpis/backoffice" className={({isActive})=>'admin-link'+(isActive?' active':'')}>🤖 KPIs Backoffice IA</NavLink>
            <NavLink to="/admin/kpis/pontualidade" className={({isActive})=>'admin-link'+(isActive?' active':'')}>⏰ Pontualidade técnicos</NavLink>
            <NavLink to="/admin/branding"        className={({isActive})=>'admin-link'+(isActive?' active':'')}>🎨 Marca</NavLink>
          </nav>
          <div style={{ marginTop: 'auto', padding: 12, fontSize: 11, color: '#9ca3af', borderTop: '1px solid #374151' }}>
            Logado como<br/><strong style={{ color: '#f3f4f6' }}>{auth?.operador?.username}</strong>
          </div>
        </aside>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
